/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLUiFragment = {
  __typename?: 'Query'
  ui: {
    __typename?: 'Ui'
    glossary: {
      __typename?: 'LexicalGlossary'
      datingProfile: {
        __typename?: 'DatingProfileLexicalDictionary'
        alcohol: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        appearance: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        children: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        constitution: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        datingGoals: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        education: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        homeStatus: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        knownLanguages: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        lookFor: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        materialStatus: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        orientation: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        smoking: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
      }
    }
    giftFormats: Array<{
      __typename?: 'GiftImageFormatType'
      formatId: number
      urlTemplate: string
      type: Types.GQLGiftImageKind
    }>
  }
}

export type GQLGiftFormatsFragment = {
  __typename?: 'Ui'
  giftFormats: Array<{
    __typename?: 'GiftImageFormatType'
    formatId: number
    urlTemplate: string
    type: Types.GQLGiftImageKind
  }>
}

export type GQLLexemeFieldsFragment = {
  __typename?: 'DatingProfileLexicalOptionType'
  value?: string | null
  lexeme?: string | null
  maleLexeme?: string | null
  femaleLexeme?: string | null
}

export type GQLGlossaryFragment = {
  __typename?: 'Ui'
  glossary: {
    __typename?: 'LexicalGlossary'
    datingProfile: {
      __typename?: 'DatingProfileLexicalDictionary'
      alcohol: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      appearance: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      children: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      constitution: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      datingGoals: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      education: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      homeStatus: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      knownLanguages: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      lookFor: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      materialStatus: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      orientation: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
      smoking: Array<{
        __typename?: 'DatingProfileLexicalOptionType'
        value?: string | null
        lexeme?: string | null
        maleLexeme?: string | null
        femaleLexeme?: string | null
      }>
    }
  }
}

export const LexemeFieldsFragmentDoc = gql`
  fragment LexemeFields on DatingProfileLexicalOptionType {
    value
    lexeme
    maleLexeme
    femaleLexeme
  }
`
export const GlossaryFragmentDoc = gql`
  fragment Glossary on Ui {
    glossary {
      datingProfile {
        alcohol {
          ...LexemeFields
        }
        appearance {
          ...LexemeFields
        }
        children {
          ...LexemeFields
        }
        constitution {
          ...LexemeFields
        }
        datingGoals {
          ...LexemeFields
        }
        education {
          ...LexemeFields
        }
        homeStatus {
          ...LexemeFields
        }
        knownLanguages {
          ...LexemeFields
        }
        lookFor {
          ...LexemeFields
        }
        materialStatus {
          ...LexemeFields
        }
        orientation {
          ...LexemeFields
        }
        smoking {
          ...LexemeFields
        }
      }
    }
  }
  ${LexemeFieldsFragmentDoc}
`
export const GiftFormatsFragmentDoc = gql`
  fragment GiftFormats on Ui {
    giftFormats {
      formatId
      urlTemplate
      type
    }
  }
`
export const UiFragmentDoc = gql`
  fragment Ui on Query {
    ui {
      ...Glossary
      ...GiftFormats
    }
  }
  ${GlossaryFragmentDoc}
  ${GiftFormatsFragmentDoc}
`
